import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { SignaturesService } from '../../signatures/services/signatures.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { resetFormText, setFormText } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setSignatureType } from '../../customSignature/store/customSignature.actions'

export function* getFormText() {
  const serviceId: string = yield select(getServiceIdSelector)
  const signaturesService = new SignaturesService(serviceId)
  try {
    const response = yield call([signaturesService, signaturesService.getSignatureFormText])
    const { entity } = response
    if (entity && entity.length > 0) {
      const { header_text, ack_text, section_i_text, section_ii_text, section_iii_text } = entity[0]
      yield put(setFormText(header_text, ack_text, section_i_text, section_ii_text, section_iii_text))
      yield put(setSignatureType('standardSignature'))
    } else {
      yield put(resetFormText())
      yield put(setSignatureType('customSignature'))
    }
  } catch (e) {
    yield put(throwPcrException(`getFormText() error: ${e}`))
  }
}
export function* getFormTextSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getFormText)
}
